module.exports = __webpack_public_path__ + "img/icon-exchange.fac34951.png";